import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

@Component({
  selector: 'lfx-meeting-password-required',
  templateUrl: './meeting-password-required.component.html',
  styleUrls: ['./meeting-password-required.component.scss'],
  standalone: true,
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MeetingPasswordRequiredComponent {}
